import { Share, Download, X, MoreVertical } from "lucide-react";
import { C } from "../constants/colors";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

// Slim, dismissible "Add to Home Screen" nudge. Renders nothing once the app
// is installed, once dismissed, or when there's nothing actionable to show.
// Sits in normal flow just above the mobile BottomNav (no fixed positioning,
// so it never overlaps the nav).

export function InstallBanner({ isMobile }) {
  const { deferredPrompt, installed, dismissed, dismiss, promptInstall, platform } =
    useInstallPrompt();

  if (installed || dismissed) return null;

  // Decide what to show.
  let mode = null;
  if (deferredPrompt) mode = "install";            // Chrome / Edge / Android
  else if (isMobile && platform === "ios") mode = "ios";
  else if (isMobile && (platform === "ios-inapp" || platform === "android-inapp")) mode = "inapp";

  if (!mode) return null;

  const wrap = {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    background: C.indigo,
    borderTop: `1px solid ${C.teal}44`,
    color: "#e8e8ef",
    fontSize: 13,
    lineHeight: 1.35,
    animation: "fadeUp 0.25s ease",
  };

  const dismissBtn = (
    <button
      onClick={dismiss}
      aria-label="Dismiss"
      style={{
        flexShrink: 0,
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#888",
        padding: 4,
        display: "flex",
        alignItems: "center",
      }}
    >
      <X size={16} />
    </button>
  );

  if (mode === "install") {
    return (
      <div style={wrap}>
        <Download size={18} color={C.tealLight} style={{ flexShrink: 0 }} />
        <span style={{ flex: 1 }}>Add Brill to your home screen for the best experience.</span>
        <button
          onClick={promptInstall}
          style={{
            flexShrink: 0,
            background: C.tealLight,
            color: C.indigo,
            border: "none",
            borderRadius: 8,
            padding: "7px 14px",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Install
        </button>
        {dismissBtn}
      </div>
    );
  }

  if (mode === "ios") {
    return (
      <div style={wrap}>
        <Share size={18} color={C.tealLight} style={{ flexShrink: 0 }} />
        <span style={{ flex: 1 }}>
          Add Brill to your home screen: tap the <strong>Share</strong> icon, then{" "}
          <strong>Add to Home Screen</strong>.
        </span>
        {dismissBtn}
      </div>
    );
  }

  // in-app browser (Instagram / Facebook / etc.) — can't install here
  return (
    <div style={wrap}>
      <MoreVertical size={18} color={C.tealLight} style={{ flexShrink: 0 }} />
      <span style={{ flex: 1 }}>
        To install Brill, open it in your browser first: tap the menu (
        <strong>⋯</strong>) and choose <strong>Open in browser</strong>.
      </span>
      {dismissBtn}
    </div>
  );
}
